import {createAsyncThunk} from "@reduxjs/toolkit";
import {saveResumePageUserData} from "@/http/api";

export const saveResumeData = createAsyncThunk(
    'resume/saveResumeData',
    async ({ pageId, resumeData }) => {
      const response = await saveResumePageUserData({ query: { pageId }, body: resumeData });
      return response.data;
    }
);